// defaultYearRange.js
export const defaultYearRangeEstimate = { startYear: 1900, endYear: new Date().getFullYear() }
